import FrasesConfirmacionListLayer from "../../components/FrasesConfirmacionListLayer";

const FrasesConfirmacionPage = () => {
  return <FrasesConfirmacionListLayer />;
};

export default FrasesConfirmacionPage;
